module.exports = __webpack_public_path__ + "static/img/Vertical.015a42e7.png";